module.exports = __webpack_public_path__ + "img/jl-banner_2.6416c929.png";